<template>
    <AppModal ref="modal" :title="$t('labels.edit_default_items')" @on-hide="hide">
        <div class="modal-body">
            <TaskProgressBar v-if="fetchTask.state.isRunning" :done="fetchTask.state.done" :total="fetchTask.state.total"/>
            <TaskProgressBar v-if="updateTask.state.isRunning" :done="updateTask.state.done" :total="updateTask.state.total"/>
            <table v-if="!fetchTask.state.isRunning && !updateTask.state.isRunning" class="table table-bordered table-fixed">
                <thead>
                    <tr>
                        <th width="50%">{{ $t('labels.filter') }}</th>
                        <th width="50%">{{ $t('labels.filter_item') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="filter in filters">
                        <td>{{ filter.name }}</td>
                        <td>
                            <CatalogAttributeSelect
                                :attribute="toAttributeFormat(filter)"
                                :integration="integration"
                                :category="category"
                                :model-value="filter.defaultItems"
                                @update:model-value="filter.defaultItems = $event"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="modal-footer justify-content-end" v-if="!fetchTask.state.isRunning && !updateTask.state.isRunning">
            <AppButton color="indigo" @click="updateDefaultItems">
                {{ $t('buttons.edit') }}
            </AppButton>
        </div>
    </AppModal>
</template>
<script>
import AppModal from '../../../../../../components/new/modal/AppModal.vue';
import AppButton from '../../../../../../components/new/button/AppButton.vue';
import CatalogAttributeSelect from '../../products/edit/CatalogAttributeSelect.vue';
import TaskProgressBar from '../../../../../../components/new/progress/TaskProgressBar.vue';

import { httpClient } from '../../../../../../services/HttpClient';
import HttpSender from '../../../../../../services/Http/HttpSender';
import HttpRequest from '../../../../../../services/Http/HttpRequest';
import { createProgressTask } from '../../../../../../services/Progress/ProgressTask';

export default {
    name: "EditDefaultItemsModal",
    components: {
        AppModal, AppButton, CatalogAttributeSelect, TaskProgressBar
    },
    emits: ['default-items:updated'],
    props: {
        integration: {
            type: Object,
            required: true
        },
        category: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            fetchTask: createProgressTask(),
            updateTask: createProgressTask(),
            filters: []
        }
    },
    methods: {
        toAttributeFormat(filter) {
            return {
                ...filter,
                is_multiple: filter.isMultiple,
                source_id: filter.sourceId,
                allow_custom_values: filter.allowCustomValues,
            };
        },
        show(selectedFiltersUuids) {
            this.$refs.modal.show();

            this.fetchTask.run(async ({signal}) => {
                const filters = await this.fetchFilters(selectedFiltersUuids);

                if (!signal.aborted) {
                    this.filters = filters;
                }
            });
        },
        hide() {
            this.fetchTask.cancel();
            this.updateTask.cancel();
            this.$refs.modal.hide();
            this.filters = [];
        },
        async fetchFilters(selectedFiltersUuids) {
            let filters = [];

            await httpClient.get(`/projects/${this.$route.params.projectUuid}/pim/channels/${this.$route.params.integrationUuid}/filters`, {
                integration_category_uuids: [this.$route.params.categoryUuid],
                uuids: selectedFiltersUuids,
                extra_fields: ['defaultItems'],
                limit: 100
            }).then(response => {
                filters = response.data.data.map(filter => {
                    return {
                        uuid: filter.uuid,
                        name: filter.name,
                        isMultiple: filter.is_multiple,
                        sourceId: filter.source_id,
                        allowCustomValues: filter.allow_custom_values,
                        defaultItems: filter.default_items
                    }
                });
            });

            return filters;
        },
        async updateDefaultItems() {
            const requests = this.filters.map(filter => new HttpRequest('PATCH', `/projects/${this.$route.params.projectUuid}/pim/channels/${this.$route.params.integrationUuid}/filters/${filter.uuid}`, {
                default_item_uuids: filter.defaultItems.map(item => item.uuid)
            }));

            const completed = await this.updateTask.run(async ({setTotal, tick}) => {
                setTotal(requests.length);

                await new HttpSender().sendRequestsInBatches(requests, () => tick());
            });

            if (completed) {
                this.$emit('default-items:updated');
                this.hide();
            }
        }
    },
    beforeUnmount() {
        this.fetchTask.cancel();
        this.updateTask.cancel();
    }
}
</script>